import { exportReport } from 'partner360/services/report/exportReport'

export const exportGlobalFinData = (
  fYear: number,
  globalPartnerId: string,
  globalPartnerName: string
) => {
  return exportReport({
    filename: `${globalPartnerName}_Financial Analytics Report.xlsx`,
    entryId: 236,
    headerEntryIds: [249],
    mappings: { FYear: fYear, GlobalPartnerId: globalPartnerId },
  })
}
